import React from "react"
import { AppToolbarCreateButton } from "@components"

import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"
import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"


export default function CreateAlertsButton() {

	const { onGenerateAlert } = useAlertsTableData()

	return <AppToolbarCreateButton
		data-tour-id="tour-new-condition"
		icon="cowbell-circle-plus"
		label="New condition"
		tooltip="New condition"
		onClick={() => alertsDrawerData.value = onGenerateAlert({ type: alertsSection.value })}
	/>
}
